module.exports = __webpack_public_path__ + "img/Butterfly_00108.faa6c10b.png";